import {
    CREATE_SECURITY_URL,
    SET_SECURITY_URL_LIST,
    REQUEST_SECURITY_URL_LIST,
    REQUEST_DELETE_SECURITY_URL,
    SET_PAGE,
} from './constants'

export function createSecurityUrl(url) {
    return {
        type: CREATE_SECURITY_URL,
        payload: {
            url
        }
    }
}

export function setSecurityUrlList( {payload: {security_urls, pagination} }) {
    return {
        type: SET_SECURITY_URL_LIST,
        payload: {
            security_urls,
            pagination
        }
    }
}

export function requestSecurityUrlList(page = 1) {
    return {
        type: REQUEST_SECURITY_URL_LIST,
        payload:  {
            page
        }
    }
}

export function requestDeleteSecurityUrl(security_url_id) {
    return {
        type: REQUEST_DELETE_SECURITY_URL,
        payload: {
            security_url_id
        }
    }
}

export function setPage({ page }) {
    return {
        type: SET_PAGE,
        payload: {
            page
        }
    }
}